import { ArrowLeft } from "@phosphor-icons/react";
import { Link } from "react-router-dom";
import { Footer } from "./Footer";

export const LegalLayout = ({ title, updatedAt, children }) => (
  <div className="min-h-screen bg-white">
    <header className="fixed top-0 z-50 w-full border-b border-black/5 bg-white/85 py-3 backdrop-blur-xl">
      <div className="mx-auto flex max-w-8xl items-center justify-between px-5 md:px-10">
        <Link to="/" data-testid="legal-brand-logo" className="flex items-center gap-2">
          <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-maraca-navy font-display text-lg font-extrabold text-white">M</span>
          <span className="font-display text-xl font-extrabold tracking-tight text-maraca-navy">
            Delivery <span className="text-maraca-teal">Maracás</span>
          </span>
        </Link>
        <Link
          to="/"
          data-testid="legal-back-home"
          className="inline-flex items-center gap-2 rounded-full border border-black/10 px-4 py-2 text-sm font-bold text-maraca-navy transition-colors hover:bg-maraca-teal/10"
        >
          <ArrowLeft size={18} weight="bold" /> Voltar ao site
        </Link>
      </div>
    </header>

    <main className="mx-auto max-w-3xl px-5 pb-24 pt-32 md:px-8 md:pt-40">
      <p className="font-mono text-xs font-bold uppercase tracking-[0.2em] text-maraca-teal">Delivery Maracás</p>
      <h1 className="mt-3 font-display text-4xl font-extrabold tracking-tight text-maraca-navy md:text-5xl">{title}</h1>
      <p className="mt-4 text-sm text-maraca-navy/50">Última atualização: {updatedAt}</p>
      <div className="legal-prose mt-10 space-y-8">{children}</div>
    </main>

    <Footer />
  </div>
);

export const LegalSection = ({ n, title, children }) => (
  <section>
    <h2 className="font-display text-xl font-bold text-maraca-navy md:text-2xl">
      <span className="mr-2 font-mono text-maraca-teal">{n}.</span>
      {title}
    </h2>
    <div className="mt-3 space-y-3 leading-relaxed text-maraca-navy/75">{children}</div>
  </section>
);
